import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[greenText]',
})
export class GreenTextDirective {
  @Input() greenText: boolean;

  constructor(el: ElementRef) {
    setTimeout(() => {
      console.log(this.greenText);
      if (this.greenText) {
        el.nativeElement.style.color = '#32a852';
        el.nativeElement.style.fontWeight = 'bold';
      }
    });
  }
}
